import { toast } from 'react-toastify'

import { MODAL_TYPE } from 'Defaults/modals'

export function share(userIsAgent, isMobile, shareUrl, title, shareModalInfo, openModal, isMobileApp = false) {
  if(isMobileApp && !userIsAgent && typeof window !== 'undefined') {
    window.Median?.share.sharePage({
      text: title,
      url: shareUrl,
    })
  } else if(navigator.share && !userIsAgent && isMobile) {
    navigator.share({
      title,
      text: title,
      url: shareUrl,
    })
      .then(() => toast.success('Success!'))
      // eslint-disable-next-line
      .catch((error) => console.log('Error sharing', error))
  } else {
    openModal({
      modalType: MODAL_TYPE.SHARE_PAGE,
      ...shareModalInfo,
    })
  }
}
